
<template>
  <div class="footer-component flex-xy-center">
    <i class="ico ico-icon_49 marginr-10"></i><span class="col-fcGreyish">枫车仅提供技术支持</span>
  </div>
</template>

<script >
export default {
    name: 'fc-footer',
    data () {
        return {

        }
    },
    created () {

    },
    activated () {

    },
    mounted () {

    },
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variables'
.footer-component
  width 100%
  height 88px
  padding 25px 30px 25px 30px
  width 100%
  box-sizing border-box
  position relative
  bottom 0
  left 0px
  font-size 24px
</style>
